import axios from "axios";

const module = {
    namespaced: true,
    state: {
        post: [],
        postSingle: {
            price: null
        },
        postPayment: []
    },
    mutations: {
        setConsult: (state, info) => {
            state.post = info
        },
        setConsultationSingle: (state, info) => {
            state.postSingle = info
        },
        setPayment: (state, info) => {
            state.postPayment = info
        },
        updatePayment: (state, info) => {
            return state.postPayment = state.postPayment.map((item) => {
                if (item.id == info.consultation_payment.id) {
                    info.consultation_payment.user = item.user
                    item = info.consultation_payment
                }
                return item
            })
        },
        updateConsultation: (state, info) => {
            return state.post = state.post.map((item) => {
                if (item.id === info.personal_consultation.id) {
                    info.personal_consultation.user = item.user
                    item = info.personal_consultation
                }
                return item
            })
        },
        setConsultUserId: (state, info) => {
            state.post = info
        }
    },

    actions: {
        async fetchConsul({commit}) {
            const response = await axios.get('admin/personal-consultation?excludeStates=[5]')
            commit('setConsult', response.data.personal_consultations.reverse())
        },
        async fetchConsultationSingle({commit}, data) {
            const response = await axios.get(`admin/personal-consultation/${data.id}`)
            commit('setConsultationSingle', response.data.personal_consultation)
        },
        async fetchPayment({commit}, data) {
            const response = await axios.get(`admin/personal-consultation/${data.id}/payments`)
            commit('setPayment', response.data.consultation_payments)
        },
        async updateDataConsultation({commit}, data) {
            console.log('updateDataConsultation')
            const response = await axios.put(`admin/personal-consultation/${data.id}`, data.data)
            commit('updateConsultation', response.data)
        },
        async updatePaymentId({commit}, data) {
            const response = await axios.put(`admin/personal-consultation/${data.id}/payments/${data.pay}`, data.data)
            commit('updatePayment', response.data)
        },
        async fetchConsulUserId({commit}, data) {
            const response = await axios.get(`admin/personal-consultation?user_id=${data.id}`)
            commit('setConsultUserId', response.data.personal_consultations.reverse())
        }
    }
}
export default module
